let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bxnv2")).then(() => parcelRequire('dqid6'));